import React from "react";

function LeadDetailsCanvas({ lead, onClose, onCreateOpportunity }) {
  if (!lead) return null;

  return (
    <div className="fixed inset-0 flex justify-end z-50">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose}></div>
      
      <div className="relative w-full max-w-lg h-full bg-white shadow-lg flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b bg-gray-100">
          <h2 className="text-xl font-semibold text-gray-800">Lead Details</h2>
          <button className="text-gray-600 hover:text-gray-900 text-2xl" onClick={onClose}>
            &times;
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          {/* Contact Details */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Contact Details</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              {/* Updated Contact Fields */}
              <p>
                <strong className="text-gray-600">Name:</strong>
                {`${lead.first_name || ''} ${lead.last_ame || ''}`.trim() || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Phone:</strong>
                {lead.phone || lead.phone || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Email:</strong>
                {lead.email || 'N/A'}
              </p>
              {/* Updated Assigned To */}
              <p>
                <strong className="text-gray-600">Assigned To:</strong>
                {lead.User?.username ? `${lead.User.username} (${lead.User.email})` : 'Unassigned'}
              </p>
            </div>
          </div>

          {/* Lead Information */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Lead Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              {/* Updated Organization/Branch display */}
              <p>
                <strong className="text-gray-600">Organization:</strong>
                {lead.Organization?.name || lead.organization || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Branch:</strong>
                {lead.Branch?.name || lead.branch || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Source:</strong>
                {lead.LeadSource?.name || lead.source || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Status:</strong>
                {lead.LeadStatus?.name || lead.status || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Priority:</strong>
                {lead.priority || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Service Category:</strong>
                {lead.ServiceCategory?.name || lead.service_category || 'N/A'}
              </p>
            </div>
          </div>

          {/* Additional Details */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Additional Details</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <p>
                <strong className="text-gray-600">Estimated Value:</strong>
                ₹{lead.estimated_value?.toLocaleString() || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Probability:</strong>
                {lead.probability ? `${lead.probability}%` : 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Expected Close:</strong>
                {lead.expected_close_date || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">City:</strong>
                {lead.city || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Social Media:</strong>
                {lead.social_ids ? 
                  Object.entries(lead.social_ids).map(([key, value]) => (
                    <a key={key} href={value} className="text-blue-600 hover:underline block" target="_blank" rel="noopener noreferrer">
                      {key}
                    </a>
                  )) : 'N/A'}
              </p>
            </div>
          </div>

          {/* Timestamps */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Timestamps</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <p>
                <strong className="text-gray-600">Created At:</strong>
                {new Date(lead.created_at).toLocaleString() || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Updated At:</strong>
                {new Date(lead.updated_at).toLocaleString() || 'N/A'}
              </p>
              <p>
                <strong className="text-gray-600">Inquiry Date:</strong>
                {lead.inquiry_date ? new Date(lead.inquiry_date).toLocaleDateString() : 'N/A'}
              </p>
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="p-4 border-t bg-gray-100 flex justify-end space-x-4">
          <button
            className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-500"
            onClick={() => alert("Lead qualified!")}
          >
            Qualify
          </button>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-500"
            onClick={() => onCreateOpportunity(lead)}
          >
            Create Opportunity
          </button>
        </div>
      </div>
    </div>
  );
}

export default LeadDetailsCanvas;